/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'

// import {Select} from '../../../../../../components/UI/Select'

import {ChangeRoomDetailModel} from '../../../../models/change-rooms.model'
import {getBookingsChangeRoomsDetailService} from '../../../../services/change-rooms.service'

const TableChangeRoomsDetail: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem} = useHoteleria()

  const getChangeRooms = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBookingsChangeRoomsDetailService(currentTabItem.idToEdit)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getChangeRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getChangeRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    // setLoading(loading)
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const columns: Column<ChangeRoomDetailModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Modulo' />,
      accessor: 'NomenclaturaModulo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Habitacion' />,
      accessor: 'NomenclaturaHabitacion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitacion' />,
      accessor: 'TipoHabitacion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama' />,
      accessor: 'NomenclaturaCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Cama' />,
      accessor: 'TipoCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama Caliente' />,
      accessor: 'CamaCaliente',
      Cell: ({...props}) => <div>{props.row.original.CamaCaliente ? 'SI' : 'NO'}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Piso' />,
      accessor: 'Piso',
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Inicio' />,
      accessor: 'ReservaFechaIni',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Fin' />,
      accessor: 'ReservaFechaFin',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Huesped' />,
      accessor: 'HuespedNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Reserva' />,
      accessor: 'EstadoReserva',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado Cambio Hab.' />,
      accessor: 'EstadoCambioHabitacion',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableChangeRoomsDetailWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      {isAllowed('CAMBIOHABITACIONES/LISTAR') && <TableChangeRoomsDetail />}
    </KTableProvider>
  )
}

export {TableChangeRoomsDetailWrapper}
